import React, { useEffect, useState } from "react";
import { BookOpen, Quote } from "lucide-react";
import Navbar from "../components/public/Navbar";
import Footer from "../components/public/Footer";
import BookCard from "../components/common/BookCard";
import BundleOffer from "../components/common/BundleOffer";
import { fetchBooks } from "../lib/api";

const AUTHOR_PHOTO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_rehab-management-1/artifacts/vtb5lltt_image.png";

export default function BooksPage() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchBooks().then(setBooks).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <Navbar />

      {/* Header */}
      <section className="bg-navy pt-40 sm:pt-48 pb-16 relative overflow-hidden">
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
          <div className="inline-flex items-center gap-2 bg-navy-light text-gold-light px-4 py-1.5 rounded-full text-sm font-medium mb-5">
            <BookOpen className="h-4 w-4" /> Word on Wealth (WOW) Series
          </div>
          <h1 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
            Books by <span className="text-gold">Phil Dickens</span>
          </h1>
          <p className="mt-4 text-gray-300 text-base md:text-lg max-w-2xl leading-relaxed">
            Instant digital downloads — practical, faith-based guides to protect your home,
            master your credit, and build lasting wealth.
          </p>
        </div>
      </section>

      {/* About the author */}
      <section className="py-16 sm:py-20 bg-navy relative overflow-hidden" data-testid="about-author-section">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
        <div className="max-w-5xl mx-auto px-4 sm:px-6 grid md:grid-cols-[260px_1fr] gap-10 items-start relative">
          <div className="mx-auto md:mx-0">
            <img
              src={AUTHOR_PHOTO}
              alt="Phil Dickens"
              className="w-56 h-56 md:w-64 md:h-64 object-cover rounded-2xl shadow-2xl ring-4 ring-gold/60"
              data-testid="author-photo"
            />
          </div>
          <div>
            <div className="text-gold-light text-sm font-medium uppercase tracking-wider">About the Author</div>
            <h2 className="font-serif text-white text-3xl sm:text-4xl font-bold mt-2">Phil Dickens</h2>
            <p className="mt-4 text-gray-300 leading-relaxed">
              Phil Dickens is an author and financial educator on a mission to put the tools of
              wealth back into the hands of everyday people.
            </p>
            <p className="mt-3 text-gray-300 leading-relaxed">
              Through the Word on Wealth (WOW) series, published by CGM Publishing (Covenant Group
              Ministries), Phil distills years of study and lived experience into clear processes
              and procedures anyone can follow. Commerce is more than credit — understanding your
              buying power can bring you much wealth.
            </p>
            <blockquote className="mt-6 border-l-4 border-gold pl-4">
              <div className="flex items-start gap-2">
                <Quote className="h-5 w-5 text-gold mt-1 shrink-0" />
                <p className="font-serif text-gold-light text-xl italic">"Change your Choices, Change your life."</p>
              </div>
              <footer className="text-gray-400 text-sm mt-2 pl-7">— Phil Dickens, CGM Publishing</footer>
            </blockquote>
          </div>
        </div>
      </section>

      {/* Books grid */}
      <section className="py-14 sm:py-20 bg-cream/50" data-testid="books-grid-section">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 space-y-10">
          <BundleOffer />
          {loading ? (
            <p className="text-center text-gray-400 py-16">Loading books…</p>
          ) : (
            <div className="grid sm:grid-cols-2 gap-8">
              {books.map((b) => (
                <BookCard key={b.id} book={b} />
              ))}
              {books.length === 0 && (
                <p className="col-span-2 text-center text-gray-400 py-16">No books available yet — check back soon.</p>
              )}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
